import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';
import { includes } from 'lodash/fp';
import { injectIntl } from 'react-intl';
import { Spinner } from '../../common/components';

const supportedLocales = ['en', 'ko', 'ja', 'zh-CN', 'zh-TW'];

export const Root = ({ intl, location }) => {
  const [locale, setLocale] = useState(null);

  useEffect(() => {
    setLocale(includes(intl.locale, supportedLocales) ? intl.locale : 'en');
  }, [intl.locale]);

  return (
    locale === null
      ? <Spinner />
      : (
        <Redirect
          to={{
            pathname: `/${locale}`,
            state: { from: location.pathname },
          }}
        />
      )
  );
};

Root.propTypes = {
  intl: PropTypes.shape({
    locale: PropTypes.string.isRequired,
  }).isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
    search: PropTypes.string.isRequired,
  }).isRequired,
};

export default injectIntl(Root);
